<template>
  <div class="projects" v-if="dataSource">
    <h2 class="projects__title">Проект:</h2>
    <div class="projects__tabs tabs">

      <div class="tabs__list">
        <BaseTabButton
          text="Сайт"
          :checked="dataSource?.SdtEnabled"
          :active="activeTab === 1 && dataSource.SdtEnabled"
          @change-input="dataSource.SdtEnabled = !dataSource.SdtEnabled"
          @click-tab="selectTab(1)"
        />
        <!-- <BaseTabButton
          text="Уч. центр"
          :checked="dataSource?.TrainingEnabled"
          :active="activeTab === 2 && dataSource.TrainingEnabled"
          @change-input="dataSource.TrainingEnabled = !dataSource.TrainingEnabled"
          @click-tab="selectTab(2)"
        /> -->
        <!-- <BaseTabButton
          text="Архив"
          :checked="dataSource?.ArchiveEnabled"
          :active="activeTab === 3 && dataSource.ArchiveEnabled"
          @change-input="dataSource.ArchiveEnabled = !dataSource.ArchiveEnabled"
          @click-tab="selectTab(3)"
        /> -->
      </div>

      <div class="tabs__content">
        <Transition  name="content" mode="out-in">
          <RolesEditorProjectsSite
            v-if="activeTab === 1 && dataSource.SdtEnabled"
          />
          <RolesEditorProjectsEducation
            v-else-if="activeTab === 2 && dataSource.TrainingEnabled"
          />
          <RolesEditorProjectsArchive
            v-else-if="activeTab === 3 && dataSource.ArchiveEnabled"
          />
        </Transition>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import BaseTabButton from '@/components/ui/BaseTabButton.vue'
import RolesEditorProjectsSite from '@/components/blocks/RolesEditorProjectsSite.vue'
import RolesEditorProjectsEducation from '@/components/blocks/RolesEditorProjectsEducation.vue'
import RolesEditorProjectsArchive from '@/components/blocks/RolesEditorProjectsArchive.vue'

export default {
  name: 'RolesEditorProjects',
  components: {
    BaseTabButton,
    RolesEditorProjectsSite,
    RolesEditorProjectsEducation,
    RolesEditorProjectsArchive
  },
  setup () {
    const store = useStore()

    const dataSource = computed(() => store.getters.getUserForm.UserClaims)

    const activeTab = ref(1)

    const selectTab = (val) => {
      activeTab.value = val
    }

    return {
      activeTab,
      selectTab,
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
.projects {
  // max-width: 866px;

  &__title {
    text-align: start;
    margin-bottom: 20px;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: -0.4px;
    color: #000000;
  }

  &__tabs, .tabs {
    &__list {
      margin-bottom: 30px;
      display: flex;
      justify-content: flex-start;
      gap: 30px;
    }
  }
}

.content-enter-active,
.content-leave-active {
  transition: all 0.25s ease-out;
}

.content-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.content-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

// стили для аккордионов
:deep(.p-accordion-header-action) {
  flex-direction: row-reverse;
  justify-content: space-between;
}
</style>
